import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { first } from 'rxjs/operators';

import { YearsService } from '../../../@core/utils';
import { YearSelectorComponent } from '../year-selector/year-selector.component';

@Component({
    selector: 'app-year-range-input',
    styleUrls: ['./year-range-input.component.scss'],
    templateUrl: './year-range-input.component.html',
    standalone: true,
    imports: [YearSelectorComponent],
})
export class YearRangeInputComponent implements OnInit, OnDestroy {

  public startYear: number;
  public endYear: number;

  private subscription: Subscription;

  constructor(
    private yearsService: YearsService,
  ) { }

  public ngOnInit(): void {
    this.subscription = combineLatest([
      this.yearsService.startYear$,
      this.yearsService.endYear$,
    ]).pipe(first()).subscribe(([startYear, endYear]) => {
      this.startYear = startYear;
      this.endYear = endYear;
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public startYearChanged(startYear: number): void {
    this.startYear = startYear;

    if (this.endYear < this.startYear) {
      this.endYear = this.startYear;
    }

    this.yearUpdate();
  }

  public endYearChanged(endYear: number): void {
    this.endYear = endYear;

    if (this.startYear > this.endYear) {
      this.startYear = this.endYear;
    }

    this.yearUpdate();
  }

  private yearUpdate(): void {
    this.yearsService.setStartYear(this.startYear);
    this.yearsService.setEndYear(this.endYear);
    window.location.reload();
  }

}
